import { createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-10241cac")

_pushScopeId("data-v-10241cac")
const _hoisted_1 = { class: "AdditionalServicesOnDelivery" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "AdditionalServicesOnDelivery__title" }, "Дополнительные услуги при доставке", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "AdditionalServicesOnDelivery__hint" }, "(не обязательно)", -1)
const _hoisted_4 = { class: "AdditionalServicesOnDelivery__content" }
const _hoisted_5 = { class: "AdditionalServicesOnDelivery__actions" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Сбросить ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Подтвердить ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_s_checkbox = _resolveComponent("s-checkbox")!
  const _component_new_button = _resolveComponent("new-button")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_s_checkbox, {
        disabled: _ctx.disabled || _ctx.setted,
        value: _ctx.state.hasManipulator,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.hasManipulator = $event)),
        theme: "primary",
        label: "Манипулятор"
      }, null, 8, ["disabled", "value"]),
      _createVNode(_component_s_checkbox, {
        disabled: _ctx.disabled || _ctx.setted,
        value: _ctx.state.hasCrane,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.hasCrane = $event)),
        theme: "primary",
        label: "Кран"
      }, null, 8, ["disabled", "value"]),
      _createVNode(_component_s_checkbox, {
        disabled: _ctx.disabled || _ctx.setted,
        value: _ctx.state.hasHydraulicTrolley,
        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.hasHydraulicTrolley = $event)),
        theme: "primary",
        label: "Рохля"
      }, null, 8, ["disabled", "value"]),
      _createVNode(_component_s_checkbox, {
        disabled: _ctx.disabled || _ctx.setted,
        value: _ctx.state.hasLoaders,
        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.hasLoaders = $event)),
        theme: "primary",
        label: "Грузчики"
      }, null, 8, ["disabled", "value"])
    ]),
    _createVNode("div", _hoisted_5, [
      (_ctx.setted)
        ? (_openBlock(), _createBlock(_component_new_button, {
            key: 0,
            disabled: _ctx.disabled,
            class: "button--primary button--small button--outline",
            onClick: _ctx.onReset
          }, {
            default: _withId(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]))
        : (_openBlock(), _createBlock(_component_new_button, {
            key: 1,
            disabled: _ctx.disabled,
            class: "button--primary button--small",
            onClick: _ctx.onSubmit
          }, {
            default: _withId(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]))
    ])
  ]))
})